export const TimeConstants = {
	secondInMilliseconds: 1000,
	minuteInMilliseconds: 60000,
	hourInMilliseconds: 3.6e6,
	dayInMilliseconds: 8.64e7,
};
